// const BASE_URL = process.env.REACT_APP_BASE_URL
// const BASE_API = process.env.REACT_APP_BASE_API

const BASE_URL = "https://api.colis.resuxishop.com"
const BASE_API = "/api"
const API_ROOT = `${BASE_URL}${BASE_API}`

// export const BASE_URL_PRODUCT_MANAGEMENT = process.env.REACT_APP_BASE_URL_PRODUCT_MANAGEMENT

export const BASE_URL_PRODUCT_MANAGEMENT = "https://backend.resuxishop.com"
// export const API_KEY = process.env.REACT_APP_PRODUCT_MANAGEMENT_API_KEY

export const API_KEY =
  "zIYTwB8QeqJ1EEQrYaHbmfusw178aIlHmVK2vprLgJb2IgSTnJcntYUm4f6qNGxMYlgfgPiz2SwAQzOpJvFrtbQ0SARxZl5hNeOH0e00vUFZZ2NzI183eSufwksdIGwA"
// const BASE_API_MANAGEMENT = process.env.REACT_APP_BASE_API_PRODUCT_MANAGEMENT

const BASE_API_MANAGEMENT = "/api"

const API_ROOT_MANAGEMENT = `${BASE_URL_PRODUCT_MANAGEMENT}${BASE_API_MANAGEMENT}`

// export const API_KEY =
//   "zIYTwB8QeqJ1EEQrYaHbmfusw178aIlHmVK2vprLgJb2IgSTnJcntYUm4f6qNGxMYlgfgPiz2SwAQzOpJvFrtbQ0SARxZl5hNeOH0e00vUFZZ2NzI183eSufwksdIGwA"

// Auth Webservices
export const LOGIN = `${API_ROOT}/login`
export const FORGET_PASSWORD = `${API_ROOT}/forgetPassword`
export const CHECK_PASSWORD_TOKEN = `${API_ROOT}/validateTokenExpiration`
export const RESET_PASSWORD = `${API_ROOT}/resetPassword`
export const GET_ME = `${API_ROOT}/getMe`

// export const FIND_ALL_PACKAGES = `${API_ROOT}/packages`

// Package webservices
export const FIND_ALL_PACKAGES = `${API_ROOT}/packages`
export const FIND_ALL_TRACKING_PACKAGES = `${API_ROOT}/packages/tracking-packages`
export const TRACKING_RETURNED_PACKAGES = `${API_ROOT}/packages/returned-packages`
export const TRACKING_MISSING_PACKAGES = `${API_ROOT}/packages/missing-packages`
//*  Root package is for delete, update and find one package share the same url */
export const ROOT_PACKAGE = `${API_ROOT}/packages/package`
export const CREATE_PACKAGE = `${API_ROOT}/packages/create`
export const CALCULATE_REVENUES = `${API_ROOT}/packages/revenues`
export const CALCULATE_PACKAGES_REVENUE = `${API_ROOT}/packages/packages-revenue`
export const FIND_ALL_GOVERNORATES = `${API_ROOT}/packages/governorates`
export const PRINT_LAZAJELLA_PDF = `${API_ROOT}/packages/lazajella-pdf`
export const GENERATE_QRCODE = `${API_ROOT}/packages/generate-qrcode`
export const REFRESH_STATUS = `${API_ROOT}/packages/refresh-status`
export const REFRESH_MISSING_PACKAGES = `${API_ROOT}/packages/refresh-missing-packages`
export const UDPDATE_RETURNED_PACKAGE = `${API_ROOT}/packages/updateReturnedPackage`
export const CANCEL_PACKAGE = `${API_ROOT}/packages/cancel`
export const CANCEL_CHAHIN_PACKAGE = (packageId) => `${API_ROOT}/packages/chahin/cancel/${packageId}`
export const PRINT_CHAHIN_PACKAGE = (packageId) => `${API_ROOT}/packages/chahin/print/${packageId}`
export const PAYED_PACKAGES = `${API_ROOT}/packages/bulk/payed`
export const UDPDATE_PACKAGE_STATUS = `${API_ROOT}/packages/barcode`

// Company webservices
export const FIND_ALL_COMPANIES = `${API_ROOT}/companies`

// Notification webservices
export const FIND_LASTEST_NOTIFICATION = `${API_ROOT}/notifications/lastest-notification`
export const UPDATE_SEEN_NOTIFICATION = `${API_ROOT}/notifications/seen`

// new end points
export const CONFIRM_PACKAGE = (packageId) => `${API_ROOT}/packages/confirm/${packageId}`
export const CONFIRM_MULTIPLE_PACKAGES = `${API_ROOT}/packages/confirm-multiple`
// export const DELETE_UNCONFIRMED_PACKAGE = (packageId) => `${API_ROOT}/packages/delete-unconfirmed/${packageId}`

// ? Management END POINTS
// GET Product
export const SEARCH_PRODUCT = `${API_ROOT_MANAGEMENT}/products/resuxi`

// Stock Movements
export const CREATE_PRODUCT_CMD = `${API_ROOT_MANAGEMENT}/stock-movement`
export const UPDATE_PRODUCT_CMD = (refPackage) => `${API_ROOT_MANAGEMENT}/stock-movement/ref/${refPackage}`
export const DELETE_PRODUCT_CMD = (refPackage) => `${API_ROOT_MANAGEMENT}/stock-movement/ref/${refPackage}`
export const GET_STOCK_MOVEMENT_BY_REF = (refPackage) => `${API_ROOT_MANAGEMENT}/stock-movement/ref/${refPackage}`

// Client
export const FIND_ALL_CLIENTS = `${API_ROOT}/clients`
export const SEARCH_CLIENTS = `${API_ROOT}/clients/search`
export const GET_CLIENT = (clientId) => `${API_ROOT}/clients/${clientId}`
export const CREATE_CLIENT = `${API_ROOT}/clients/create`
export const UPDATE_CLIENT = (clientId) => `${API_ROOT}/clients/${clientId}`
export const DELETE_CLIENT = (clientId) => `${API_ROOT}/clients/${clientId}`

// package
export const CANCEL_UNCONFIRMED_PACKAGE = (packageId) => `${API_ROOT}/packages/cancel-unconfirmed/${packageId}`

// returns packages
export const FIND_ALL_PACKAGES_TO_RETURNED = `${API_ROOT}/packages/all-packages-to-returned`
export const MARKE_PACKAGES_AS_RETURNED = `${API_ROOT}/packages/marke-packages-as-returned`
